import type { QueueRecountAlert, TrackAnswer, TrackChartPhoto } from '@/api/calibrationChart';

// Пересчёт очереди по боксам (Алексей 21.10): плашки на фото и сводка по высланным алертам.
// Отдельно от компонента — чистая логика под vitest.

export type RecountBadge = { text: string; tone: 'changed' | 'alert' | 'ok' };

/** Плашка на фото: высланный алерт, который по новому полигону не ушёл бы, — красная; число
 *  на кадре изменилось — жёлтая «было → стало»; алерт ушёл бы и сейчас — нейтральная. */
export function recountBadge(p: TrackChartPhoto, alert?: QueueRecountAlert): RecountBadge | null {
  if (alert?.would_fire === false) return { text: `алерт ✕ ${alert.orig}→${alert.new}`, tone: 'alert' };
  if (p.x_orig != null && p.x_orig !== p.x) return { text: `${p.x_orig} → ${p.x}`, tone: 'changed' };
  if (alert?.would_fire) return { text: 'алерт ✓', tone: 'ok' };
  return null;
}

export interface RecountAlertSummary {
  total: number;
  wouldFire: number;
  /** Уходили и по новому полигону не ушли бы — по ответу валидатора. */
  lost: QueueRecountAlert[];
  lostBy: Record<Exclude<TrackAnswer, 'none'>, number>;
  /** Алерты, у которых поменялось число или исход. */
  changed: QueueRecountAlert[];
}

export function summarizeRecountAlerts(alerts: QueueRecountAlert[]): RecountAlertSummary {
  const lost = alerts.filter((a) => a.orig_fire && a.would_fire === false);
  const by = (a: TrackAnswer) => lost.filter((x) => x.answer === a).length;
  return {
    total: alerts.length,
    wouldFire: alerts.filter((a) => a.would_fire).length,
    lost,
    lostBy: { confirmed: by('confirmed'), cancelled: by('cancelled'), pending: by('pending') },
    changed: alerts.filter((a) => a.orig !== a.new || a.would_fire !== a.orig_fire),
  };
}
